<template>
  <div>
    <HubHero />
    <VerticalSelector />
    <PlatformSection />
    <HubHowItWorks />
    <ContactForm />
  </div>
</template>

<script>
import AOS from 'aos';
import HubHero from '../components/HubHero.vue';
import VerticalSelector from '../components/VerticalSelector.vue';
import PlatformSection from '../components/PlatformSection.vue';
import HubHowItWorks from '../components/HubHowItWorks.vue';
import ContactForm from '../components/ContactForm.vue';

export default {
  name: 'HubPage',
  components: {
    HubHero, VerticalSelector, PlatformSection, HubHowItWorks, ContactForm,
  },
  mounted() {
    AOS.refresh();
  },
};
</script>
